export function range(num, min, max) {
  return Math.min(Math.max(num, min), max);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vant/es/utils/format/number.js
// module id = null
// module chunks = 